<div
  *ngIf="colVm?.columnType === Types.SectionColumnProductInfoType.EnergyScore"
  appScaleDownText
  [scaleEnabled]="!(menu | isPrintMenu)"
  [style.color]="
    ignoreUserSetTextColorAndAutoToLightOrDarkTextColor
      ? (section | textColorBasedOnSectionHeaderBackgroundColor)
      : (menu | method: 'getSectionHeaderTextColor' : section)
  "
  class="section-header-general section-header-energy-score">
  {{ menu | method: 'getTypeColumnTitle' : colVm }}
</div>
